/**
 * Permission
 */
export default {
    pm: {
        Add: 'Add',
        Edit: 'Edit',
        Delete: 'Delete',
        Export: 'Export',

        Users: 'Users',
        Users_Users: 'User List',
        Users_Users_Trust: 'Trust',
        Users_Users_Export: 'Export',
        'Users_Registration-Channels': 'Registration Channels',

        Dashboard: 'Dashboard',
        Users_Overview: 'Users Overview',
        Dashboard_Features_Overview: 'Features Overview',
        Dashboard_Features_Overview_Export: 'Export',

        'Financial-Management': 'Financial Management',
        'Financial-Management_Capital-Operation-Records': 'Capital Operation Records',
        'Financial-Management_Capital-Operation-Records_Create': 'Create',

        'System-Management': 'System Management',
        'System-Management_Accounts': 'Accounts',
        'System-Management_Accounts_Create': 'Create',
        'System-Management_Accounts_Update': 'Update',
        'System-Management_Accounts_Delete': 'Delete',
        'System-Management_Roles': 'Roles',
        'System-Management_Roles_Create': 'Create',
        'System-Management_Roles_Update': 'Update',
        'System-Management_Roles_Delete': 'Delete',
        'System-Management_Configs': 'Configs',
        'System-Management_Configs_Create': 'Create',
        'System-Management_Configs_Update': 'Update',
        'System-Management_Configs_Delete': 'Delete',
        'System-Management_System-Logs': 'System Logs',
        'System-Management_Downloads': 'Downloads',
        'System-Management_Downloads_All-Data': 'All Data',
        'System-Management_Downloads_Personal-Data': 'Personal Data',

        'Client-Config': 'Client Config',
        'Client-Config_App-Version': 'App Version Config',
        'Client-Config_App-Version_Create': 'Create',
        'Client-Config_App-Version_Update': 'Update',
        'Client-Config_Content-Filter': 'Content Filter',
        'Client-Config_Content-Filter_Create': 'Add',
        'Client-Config_Content-Filter_Update': 'Update',
        'Client-Config_Content-Filter_Delete': 'Remove',

        Dramas: 'Dramas',
        Dramas_Dramas: 'Drama Management',
        Dramas_Dramas_Review: 'Review',
        Dramas_Dramas_Badge: 'Badge',
        Dramas_Dramas_Export: 'Export',
        Dramas_Dramas_Offline: 'Offline',
        'Dramas_Dramas_Heat-Coefficient': 'Heat Coefficient',
        Dramas_Comments: 'Comments',
        Dramas_Comments_Delete: 'Delete',
        'Dramas_UGC-Reports': 'UGC Reports',
        Dramas_Banner: 'Client Banner',
        Dramas_Banner_Update: 'Update',
        'Dramas_Mining-Weekly-Rewards': 'Mining Weekly Rewards',
        'Dramas_Mining-Weekly-Rewards_Review': 'Review',
        'Dramas_Mining-Weekly-Rewards_Export': 'Export',
        'Dramas_Activity-1011': 'Activity 1011',
        'Dramas_Activity-1011_Share-Review': 'Share Review',
        'Dramas_Activity-1011_Share-Review_Review': 'Review',
        'Dramas_Activity-1011_User-Stories': 'User Stories',
        'Dramas_Activity-1011_Task-Config': 'Task Config',
        'Dramas_Activity-1011_Task-Config_Update': 'Update',
    },
};
